// Normalize all time formats currently returned by order-detail.
const getItemExpectedServeTime = (item) => {
  const rawValue =
    item?.["expected-delivery-time"] ??
    item?.["expected-time"] ??
    item?.["menu-item"]?.["expected-delivery-time"] ??
    item?.["menu-item"]?.["expected-time"];

  if (rawValue === null || rawValue === undefined || rawValue === "") {
    return null;
  }

  const numericValue = Number(rawValue);
  if (Number.isFinite(numericValue) && numericValue > 0) {
    return numericValue < 1e12 ? numericValue * 1000 : numericValue;
  }

  const parsedValue = Date.parse(rawValue);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

const isItemServed = (item) =>
  Number(item?.delivered || 0) >= Number(item?.quantity || 0);

// Combo: only components cooked on KDS (need-cook) count, cancelled ones are
// skipped. Empty list => fall back to the parent combo row.
const getKdsComponents = (item) =>
  (item?._combo?.components || []).filter(
    (component) =>
      component?.["need-cook"] === true && Number(component?.quantity || 0) > 0,
  );

// Component quantity is per combo, so compare with combo quantity x quantity.
const isComponentServed = (component, comboQuantity) =>
  Number(component?.status) === 1 ||
  Number(component?.delivered || 0) >=
    Number(component?.quantity || 0) * Number(comboQuantity || 0);

// Combo: latest expected time of its KDS components.
export const getExpectedServeTime = (item) => {
  const components = getKdsComponents(item);
  if (components.length === 0) return getItemExpectedServeTime(item);

  const times = components
    .map(getItemExpectedServeTime)
    .filter((time) => time !== null);
  return times.length > 0 ? Math.max(...times) : null;
};

// Combo: served only when all of its KDS components are served.
export const isDishServed = (item) => {
  const components = getKdsComponents(item);
  if (components.length === 0) return isItemServed(item);

  const comboQuantity = item?._combo?.quantity ?? item?.quantity;
  return components.every((component) =>
    isComponentServed(component, comboQuantity),
  );
};

export const canInvokeDish = (item, now = Date.now()) => {
  if (isDishServed(item)) return false;
  const expectedAt = getExpectedServeTime(item);
  // Keep compatibility with old orders without an expected time.
  return expectedAt === null || expectedAt <= now;
};

// Combo row in lst-dish ("is-combo") has no components; attach the matching
// session combo (by line-guid) as _combo.
export const getSessionOrderItems = (session) => {
  const items = (session?.["lst-dish"] || []).map((item) => {
    if (!item?.["is-combo"]) return item;
    const combo = (session?.combos || []).find(
      (candidate) => candidate?.["line-guid"] === item?.["line-guid"],
    );
    return combo ? { ...item, _combo: combo } : item;
  });

  return items.filter(
    (item, index, list) =>
      !item?.["line-guid"] ||
      list.findIndex(
        (candidate) => candidate?.["line-guid"] === item?.["line-guid"],
      ) === index,
  );
};
